import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import LoginForm from "./features/auth/LoginForm";
import RegisterForm from "./features/auth/RegisterForm";
import ProfileUpdateForm from "./features/auth/ProfileUpdateForm";
import Markup from "./features/auth/Markup";
import Commission from "./features/auth/Commission";
import UserList from "./features/users/UserList";
import UserForm from "./features/users/UserForm";
import Index from "./features/dashboards/Index";
import Flight from "./features/flight/Flight";
import ProtectedRoute from "./components/ProtectedRoute";
import ProtectedOnboardRoute from "./components/ProtectedOnboardRoute";
import Confirmation from "./features/holiday/Confirmation";
import Booking from "./features/holiday/Booking";
import Printvoucher from "./features/holiday/Printvoucher";
// import RoundSearch from './features/flight/RoundSearch'
import FlightResultsPage from "./features/flight/FlightSearchResult";
import FlightItinerary from "./features/flight/FlightItinerary";
import Review from "./features/flight/Review";
import BookingConfirmation from "./features/flight/BookingConfirmation";
import Amendment from "./features/flight/Amendment";
import UpdatePassenger from "./features/flight/UpdatePassenger";
import BookingCalendar from "./features/booking/BookingCalendar";
import AmendmentRequest from "./features/booking/AmendmentRequest";
import GroupRequest from "./features/booking/GroupRequest";
import BnplDuereport from "./features/report/BnplDuereport";
import Ledger from "./features/report/Ledger";
import Commissionledger from "./features/report/Commissionledger";
import Depositrequest from "./features/report/Depositrequest";
import Withdrawalrequest from "./features/report/Withdrawalrequest";
import { getdomainName } from "./api/axios";
import Aboutus from "./pages/static-page/Aboutus";
import TermsConditions from "./pages/static-page/TermsConditions";
import PrivacyPolicy from "./pages/static-page/PrivacyPolicy";
import GoerPlusTnc from "./pages/static-page/GoerPlusTnc";
import ContactUs from "./pages/static-page/ContactUs";
import Faq from "./pages/static-page/Faq";
import ReferPage from "./components/ReferPage";
import AmembersOnlyWholesaleBookingSite from "./pages/static-page/AmembersOnlyWholesaleBookingSite";
import Hotel from "./features/hotel/Hotel";
import HotelSearchResults from "./features/hotel/HotelSearch";
import HotelDetails from "./features/hotel/HotelDetails";
import HotelCheckout from "./features/hotel/HotelCheckout";
import PaymentPage from "./features/hotel/Payment";
import PaymentConfirm from "./features/hotel/PaymentConfirm";
import HotelBookingCalendar from "./features/booking/HotelBookingCalendar";
import HolidayBookingCalendar from "./features/booking/HolidayBookingCalendar";
import Cancellation from "./features/hotel/Cancellation";
import NotFound from "./pages/NotFound";
import PaymentSuccess from "./pages/PaymentSuccess";
import Ticket from "./features/ticket/Ticket"
import TicketChat from "./features/ticket/TicketChat"
import CreateTicket from "./features/ticket/CreateTicket";
import SearchForm from "./features/holiday/Holiday";
import Holiday from "./features/holiday/Holiday";
import SearchResult from "./features/holiday/SearchResult";
import ThemesSearch from "./features/holiday/ThemesSearch";
import PackageDetails from "./features/holiday/PackageDetails";
import Enquiry from "./components/Enquiry";
import Thankyou from "./components/ThankYou";
import MetaPixel from "./components/MetaPixel";
import PassportApplication from "./features/passport/PassportApplication";
import PassportRequest from "./features/passport/PassportRequest";

function App() {
  // useEffect(() => {
  //   let client;
  //   if (getdomainName() === "127.0.0.1" || getdomainName() === "localhost") {
  //     client = "holidayfly";
  //   } else if (getdomainName() === "goertrip.club" || getdomainName() === "www.goertrip.club" || getdomainName() === "goertrip.com" || getdomainName() === "www.goertrip.club") {
  //     client = "goertrip";
  //   } else if (getdomainName() === "holidayfly.in" || getdomainName() === "www.holidayfly.in") {
  //     client = "holidayfly";
  //   } else if (getdomainName() === "franchise.ozilconnect.com" || getdomainName() === "franchise.goertrip.com") {
  //     client = "franchise_goertrip";
  //   } else {
  //     client = "";
  //   }

  //   const favicon = document.querySelector("link[rel='icon']") || document.createElement("link");
  //   favicon.rel = "icon";
  //   favicon.href = `/${client}/favicon.ico`;
  //   document.head.appendChild(favicon);
  // }, []);
  useEffect(() => {
    let client;
    let title;

    if (getdomainName() === "127.0.0.1" || getdomainName() === "localhost") {
      client = "holidayfly";
      title = "Holidayfly - Fastest Growing Travel Company : Book Flight, Hotel, Holidays And More...";
    }
    else if (
      getdomainName() === "goertrip.club" ||
      getdomainName() === "www.goertrip.club" ||
      getdomainName() === "goertrip.com" ||
      getdomainName() === "www.goertrip.com"
    ) {
      client = "goertrip";
      title = "GoerTrip - Book Flights, Hotels & Holiday Packages at Best Price";
    }
    else if (
      getdomainName() === "holidayfly.in" ||
      getdomainName() === "www.holidayfly.in"
    ) {
      client = "holidayfly";
      title = "Holidayfly - Fastest Growing Travel Company : Book Flight, Hotel, Holidays And More...";
    }
    else if (getdomainName() === "franchise.ozilconnect.com" || getdomainName() === "franchise.goertrip.com") {
      client = "franchise_goertrip";
      title = "GoerTrip Franchise - Travel Business Opportunity";
    } else if (getdomainName() === "b2b.ziatravels.co.in") {
      client = "ziatravels";
      title = "Zia Travels - Fastest Growing Travel Company : Book Flight, Hotel, Holidays And More...";
    } else if (getdomainName() === "b2b.clickpaytrip.com" || getdomainName() === "clickpaytrip.com") {
      client = "clickpaytrip";
      title = "clickPayTrip - Fastest Growing Travel Company : Book Flight, Hotel, Holidays And More...";
    } else {
      client = "";
      title = "Travel Booking Platform";
    }

    // Set Favicon
    const favicon =
      document.querySelector("link[rel='icon']") ||
      document.createElement("link");

    favicon.rel = "icon";
    favicon.href = `/${client}/favicon.ico`;
    document.head.appendChild(favicon);

    // Set Title
    document.title = title;

  }, []);
  return (
    <Provider store={store}>
      <BrowserRouter>
        <MetaPixel />
        <Routes>
          <Route path="Holidays/print-voucher/:BookingID" element={<Printvoucher />} />
          <Route path="/refer/:code" element={<ReferPage />} />
          <Route path="/enquiry" element={<Enquiry />} />
          <Route path="/thankyou" element={<Thankyou />} />
          {/* <Route index element={<Home />} /> */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="login" element={<LoginForm />} />
            <Route path="register" element={<RegisterForm />} />
            <Route element={<ProtectedOnboardRoute />}>
              <Route path="profile" element={<ProfileUpdateForm />} />
            </Route>
            {/* Protected routes */}
            <Route element={<ProtectedRoute />}>
              <Route path="setting" element={<Markup />} />
              <Route path="dashboard" element={<Index />} />
              <Route path="booking-calendar" element={<BookingCalendar />} />
              <Route path="report/amendment-request" element={<AmendmentRequest />} />
              <Route path="report/group-request" element={<GroupRequest />} />
              <Route path="report/bnpl-due-report" element={<BnplDuereport />} />
              <Route path="finance/ledger" element={<Ledger />} />
              <Route path="finance/commission-ledger" element={<Commissionledger />} />
              <Route path="finance/deposit-request" element={<Depositrequest />} />
              <Route path="finance/withdrawal-request" element={<Withdrawalrequest />} />
              <Route path="finance/commission" element={<Commission />} />
              <Route path="flight" element={<Flight />} />
              {/* <Route path="//flight/roundsearch" element={<RoundSearch />} /> */}
              <Route path="/flight/search" element={<FlightResultsPage />} />
              <Route path="/flight/itinerary" element={<FlightItinerary />} />
              <Route path="/flight/review/:BookingID" element={<Review />} />
              <Route path="/flight/booking-confirmation/:BookingID" element={<BookingConfirmation />} />
              <Route path="/flight/amendment/:BookingID" element={<Amendment />} />
              <Route path="/flight/update-passenger/:BookingID" element={<UpdatePassenger />} />

              <Route path="/flight/reissue/search" element={<FlightResultsPage />} />

              <Route path="users" element={<UserList />} />
              <Route path="users/create" element={<UserForm />} />
              <Route path="users/edit/:id" element={<UserForm />} />

              <Route path="hotel" element={<Hotel />} />
              <Route path="hotel/search" element={<HotelSearchResults />} />
              <Route path="hotel/details/:BookingID/:HotelID" element={<HotelDetails />} />
              <Route path="hotel/checkout/:BookingID/:HotelID/:optionID" element={<HotelCheckout />} />
              <Route path="hotel/payment/:BookingID" element={<PaymentPage />} />
              <Route path="hotel/paymentConfirmation/:BookingID" element={<PaymentConfirm />} />
              <Route path="hotel/booking-calender" element={<HotelBookingCalendar />} />
              <Route path="hotel/cancellation/:BookingID" element={<Cancellation />} />

              <Route path="ticket" element={<Ticket />} />
              <Route path="ticket/:ticketId" element={<TicketChat />} />
              <Route path="ticket/create-ticket" element={<CreateTicket />} />

              <Route path="Holidays" element={<Holiday />} />
              <Route path="Holidays/details/:packageID" element={<PackageDetails />} />
              <Route path="Holidays/Search" element={<SearchResult />} />
              <Route path="Holidays/:themes" element={<ThemesSearch />} />
              <Route path="Holidays/booking-calender" element={<HolidayBookingCalendar />} />
              <Route path="Holidays/confirmation/:BookingID/:ProID/:package_booking_id" element={<Confirmation />} />
              <Route path="Holidays/booking/:BookingID" element={<Booking />} />


              <Route path="payment/payment-success" element={<PaymentSuccess />} />
              <Route path="/passport" element={<PassportApplication />} />
              <Route path="/passport-request" element={<PassportRequest />} />



              <Route path="*" element={<NotFound />} />
            </Route>

            <Route path="cms/about-us" element={<Aboutus />} />
            <Route path="cms/terms-conditions" element={<TermsConditions />} />
            <Route path="cms/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="cms/goer-plus-tnc" element={<GoerPlusTnc />} />
            <Route path="cms/contact-us" element={<ContactUs />} />
            <Route path="cms/faq" element={<Faq />} />
            <Route path="cms/a-members-only-wholesale-booking-site" element={<AmembersOnlyWholesaleBookingSite />} />

          </Route>

        </Routes>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
